<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{ params?: { data?: any } }>()
const router = useRouter()

const href = computed(() => {
  const uuid = props.params?.data?.uuid
  return uuid ? `/dashboard/regulation/${uuid}` : null
})

const text = computed(() => props.params?.data?.quote?.quoteReference ?? '-')

function onClick(e: MouseEvent) {
  if (!href.value) return
  e.preventDefault()
  if (e.ctrlKey || e.metaKey) {
    window.open(href.value, '_blank')
  } else {
    router.push(href.value)
  }
}
</script>

<template>
  <a v-if="href" :href="href" class="link link-primary hover:underline" @click="onClick">{{ text }}</a>
  <span v-else>{{ text }}</span>
</template>
